import type { PrintingProfileDto } from "../../types/PrintingProfileDto";
import type { PrintingProfileEntity } from "../../types/PrintingProfileEntity";

export const PrintingProfileDtoToEntity = ({ ...rest }: Readonly<PrintingProfileDto>): PrintingProfileEntity => {
    return { ...rest };
};
